import script from "./SavedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedCard.vue?vue&type=script&setup=true&lang=js"

import "./SavedCard.vue?vue&type=style&index=0&id=95faf5fe&lang=css"

const __exports__ = script;

export default __exports__